import { render, staticRenderFns } from "./identityVerify.vue?vue&type=template&id=cab217e6&scoped=true&"
import script from "./identityVerify.vue?vue&type=script&lang=js&"
export * from "./identityVerify.vue?vue&type=script&lang=js&"
import style0 from "./identityVerify.vue?vue&type=style&index=0&id=cab217e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab217e6",
  null
  
)

export default component.exports